export const linkStyles = {
	textDecoration: 'none',
	'&:hover': {
		textDecoration: 'underline',
	},
};
